import { Component } from "preact";

import style from "./index.scss";

import Device from "../../components/Device";
import Settings from "../../components/Settings";

import { windowModeEnum } from '../../enums'

export default class Emulator extends Component {
  state = {
    foldSize: 0,
    shellSize: 0,
    deviceZoom: 1,
    deviceType: "duo",
    orientation: "landscape",
    url: "",
    windowMode: windowModeEnum.spanning
  };

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    let deviceType = urlParams.get("device")  || "duo";
    let url = urlParams.get('url') ||  "";
    let orientation = urlParams.get('orientation') ||  "landscape";
    this.setState({ deviceType, url, orientation }, this.setOrCreateDefaultURLParams)
  }

  setOrCreateDefaultURLParams = () =>  {
    return
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set("device", "2")
    // urlParams.set("url", this.state.url)
    // urlParams.set("orientation", this.state.orientation)
  }

  updateDeviceSettings = newSettings => {
    this.setState(Object.assign(this.state, newSettings), this.setOrCreateDefaultURLParams);
  };

  render(props, state) {
    return (
      <div class={style.emulator}>
        <Device
          updateDeviceSettings={this.updateDeviceSettings}
          deviceType={state.deviceType}
          orientation={state.orientation}
          deviceZoom={state.deviceZoom}
          url={state.url}
          windowMode={state.windowMode}
        />
        <Settings
          foldSize={state.foldSize}
          shellSize={state.shellSize}
          orientation={state.orientation}
          deviceType={state.deviceType}
          deviceZoom={state.deviceZoom}
          updateDeviceSettings={this.updateDeviceSettings}
          windowMode={state.windowMode}
        />
      </div>
    );
  }
}
